(function () {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) { return; }
    function tagSections() {
    document.querySelectorAll("#MainContent > .shopify-section").forEach(function (el) {
    el.classList.add("apple-reveal");
    });
    }
    function observeSections() {
    var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
    if (entry.isIntersecting) {
    entry.target.classList.add("is-visible");
    io.unobserve(entry.target);
    }
    });
    }, { threshold: 0.15 });
    document.querySelectorAll(".apple-reveal").forEach(function (el) {
    io.observe(el);
    });
    }
    function init() {
    tagSections();
    observeSections();
    }
    if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    } else {
    init();
    }
    })();    